import React from 'react';
import { Tag } from '@onward-delivery/design';

// The SKU roll-up's buckets, which come off forward_stocking_sku_summary as
// counts. The Status column below is finer — it resolves a lifecycle stage per
// item. "On Hand" rather than the design's "Stored", matching the column header
// and the stat card.
const BUCKETS = [
    { key: 'inbound_count', label: 'Inbound', variant: 'warning', dot: 'bg-warning' },
    { key: 'on_hand_count', label: 'On Hand', variant: 'primary', dot: 'bg-primary' },
    { key: 'outbound_count', label: 'Outbound', variant: 'info', dot: 'bg-info' },
    { key: 'return_count', label: 'Returns', variant: 'accent', dot: 'bg-accent' },
];

const ItemStatusLegend = ({ row }) => (
    <div className="flex items-center gap-3 px-1 pb-3">
        <span className="text-xs font-semibold tracking-wide text-muted">ITEM STATUS</span>
        {BUCKETS.map(({ key, label, variant, dot }) => (
            <Tag key={key} variant={variant}>
                <span className={`mr-1 inline-block h-1.5 w-1.5 rounded-full ${dot}`} />
                {`${row?.[key] ?? 0} ${label}`}
            </Tag>
        ))}
    </div>
);

export default ItemStatusLegend;
